import StoreLinkAlt from '@/components/elements/StoreLink';
import { Box, Button, Flex, Heading, Icon, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';
import { BsArrowRight, BsClock } from 'react-icons/bs';
import { Element } from 'react-scroll';

// todo https://codesandbox.io/embed/r5x34869vq

const LandingIntro = () => {
  const { t } = useTranslation(`landing`);
  return (
    <Element name="landing-intro">
      <Flex
        direction={[`column`, null, null, `row`]}
        as="section"
        align="center"
        justify="center"
        className="boxed-container"
      >
        <Box me="3" maxW={[`full`, null, `xl`]}>
          <Heading size="3xl" as="h1">
            {t(`landing_intro.header`)}
          </Heading>
          <Text mt={[5, null, 9]} lineHeight="7" fontSize={[`sm`, null, `lg`]}>
            {t(`landing_intro.sub_header`)}
          </Text>
          <Flex align="center" justify="start" mt={[5, null, 14]}>
            <StoreLinkAlt
              href="https://apps.apple.com/tr/app/voltran-app/id1567581311"
              type="ios"
            />
            <StoreLinkAlt
              href="https://play.google.com/store/apps/details?id=com.voltran.app.voltran"
              type="android"
            />
            <Button
              as={Link}
              href="#benefits"
              display={[`none`, null, `flex`]}
              colorScheme="blue"
              variant="ghost"
              px="2"
              rightIcon={<Icon as={BsArrowRight} />}
            >
              {t(`landing_intro.get_detailed_info`)}
            </Button>
          </Flex>
          <Flex
            align="center"
            justify="start"
            fontSize={[`xs`, null, `md`]}
            mt={[5, null, 9]}
            color="gray.500"
          >
            <Icon as={BsClock} h="4" w="4" me="4" />
            {t(`landing_intro.info`)}
          </Flex>
        </Box>
        <Box
          flex={1}
          mt={[14, null, 0]}
          flexDirection="column"
          minW={[`full`, null, null, `md`]}
        >
          <Box>
            <Image
              src="/images/landing/landing-section-1.png"
              alt="landing-section-1"
              height={498}
              width={772}
            />
          </Box>
          <Button
            as={Link}
            href="#benefits"
            display={[`flex`, null, `none`]}
            mt={10}
            colorScheme="blue"
            variant="ghost"
            rightIcon={<Icon as={BsArrowRight} />}
          >
            {t(`landing_intro.get_detailed_info`)}
          </Button>
        </Box>
      </Flex>
    </Element>
  );
};

export default LandingIntro;
